import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { noop } from 'lodash';
import Button from 'components/Button';
import Field from 'components/Field';
import Loading from 'components/Loading';
import { validateEmail } from 'utils/reduxForm/validations';

export default class WaitingPage extends Component {
  static propTypes = {
    user: PropTypes.instanceOf(Map).isRequired,
    incomingData: PropTypes.instanceOf(Map).isRequired,
    userEmail: PropTypes.instanceOf(Map).isRequired,
    saveEmail: PropTypes.func.isRequired,
    setEmail: PropTypes.func.isRequired,
  };

  state = {
    email: '',
    emailValidationMessage: null,
  };

  componentDidMount() {
    const { incomingData, saveEmail } = this.props;
    const incoming = incomingData.get('data');

    if (incoming && incoming.email) {
      saveEmail(incoming.email);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { userEmail, setEmail } = this.props;
    const { email: prevEmail } = prevState;
    const data = userEmail.get('data');
    const email = this.getEmail();

    if (!email && data && prevEmail) {
      setEmail(prevEmail);
    }
  }

  validateEmail = (email = '') => {
    const errorMessage = validateEmail(email);
    if (errorMessage) {
      this.setState({
        emailValidationMessage: errorMessage,
      });
    }

    return !errorMessage;
  };

  saveEmail = (e) => {
    e.preventDefault();
    const { saveEmail } = this.props;
    const { email } = this.state;
    const isValidEmail = this.validateEmail(email);

    if (email && isValidEmail) {
      saveEmail(email);
    }
  };

  onChangeEmail = (event) => {
    this.setState({
      email: event.target.value,
      emailValidationMessage: null,
    });
  };

  getEmail = () => {
    const { user, incomingData } = this.props;
    const {
      data: { email },
    } = user.toJS();
    const incoming = incomingData.get('data');
    const incomingEmail = incoming ? incoming.email : null;
    return email || incomingEmail;
  };

  renderMessage = (email) => {
    email = email ? ` ${email}` : '';
    return (
      <div>
        <p className="page_margin30">
          Мы сообщим Вам о его готовности по электронной почте{email}.
        </p>
      </div>
    );
  };

  renderEmailBlock = () => {
    const { userEmail } = this.props;
    const loading = userEmail.get('loading');
    const validationMessage = this.state.emailValidationMessage;
    const validationObject = validationMessage
      ? { validationMessage, isValid: !validationMessage }
      : {};

    return (
      <div>
        <p className="page_margin30">
          Пожалуйста, укажите электронную почту, чтобы мы могли сообщить Вам о его готовности.
        </p>
        <form onSubmit={this.saveEmail} className="form">
          <Field
            label="Адрес электронной почты"
            type="text"
            value={this.state.email}
            isValid={!validationMessage}
            {...validationObject}
            onChange={this.onChangeEmail}
          />
          <div className="cRow page_margin20">
            <div className="cCol">
              <Button
                onClick={noop}
                type="submit"
                color="orange"
                buttonStyle={{ position: 'relative', minWidth: '222px' }}
              >
                {loading ? <Loading isLight={true} /> : 'Подтвердить'}
              </Button>
            </div>
          </div>
        </form>
      </div>
    );
  };

  render() {
    const email = this.getEmail();

    return (
      <div className="main-page_center">
        <div className="main-page_cell">
          <div className="content">
            <div className="main-page_row main-page_row__small">
              <div className="white-block main-page_form">
                <p>Ваш новый Личный кабинет формируется. Это может занять некоторое время.</p>
                {email ? this.renderMessage(email) : this.renderEmailBlock()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
